module.exports = __webpack_public_path__ + "54d0e948161a863a7fcda7e9e33a2581.jpg";